module.exports = __webpack_public_path__ + "static/media/dashboard-2.b49a49c8.svg";